export const getCampaignRoutes = () => {
  const siteStore = useSiteStore();
  return Object.keys(siteStore?.config?.devConfig?.campaigns || {}).map(
    (campaign) => `/campaigns/${campaign}`,
  );
};

export const shouldRedirectCampaign = (path: string, isLoggedIn: boolean) => {
  if (!path.startsWith('/campaigns/')) return false;
  const slug = path.slice('/campaigns/'.length);
  if (!slug || slug.includes('/')) return false;

  const siteStore = useSiteStore();
  const config = siteStore?.config?.devConfig?.campaigns?.[slug];
  if (!config || config.useAuth === null) return false;

  if (isLoggedIn && (!config.useAuth || config.type === 'registration'))
    return true;

  return !isLoggedIn && !!config.useAuth;
};
